import {useQueries} from "@tanstack/react-query";
import natureService from "../../../../services/web/nature-service.js";
import userService from "../../../../services/web/user-service.js";
import teamService from "../../../../services/web/team-service.js";
import streetService from "../../../../services/web/street-service.js";
import attendanceService from "../../../../services/web/attendance-service.js";
import scheduleListService from "../../../../services/reports/schedule-list-service.js";
import placeService from "../../../../services/web/place-service.js";
import neighborhoodService from "../../../../services/web/neighborhood-service.js";

const UseFetchOptions = () => {

    const queries = useQueries({
        queries: [
            {
                queryKey: ['reason'],
                queryFn: () => natureService.naturesSchedule(),
                initialData: []
            },
            {
                queryKey: ['guard'],
                queryFn: () => scheduleListService.garrisonSchedule(),
                initialData: []
            },
            {
                queryKey: ['place'],
                queryFn: () => placeService.placeNamesSchedule(),
                initialData: []
            },
            {
                queryKey: ['neighborhood'],
                queryFn: () => neighborhoodService.neighborhoodNamesSchedule(),
                initialData: []
            },
            {
                queryKey: ['street'],
                queryFn: () => streetService.streetNamesSchedule(),
                initialData: []
            }
        ]
    });

    return {
        reasonOptions: queries[0].data,
        guardOptions: queries[1].data,
        placeOptions: queries[2].data,
        neighborhoodOptions: queries[3].data,
        streetOptions: queries[4].data
    };
};

export default UseFetchOptions;